module.exports = __webpack_public_path__ + "static/assets/bfb4e4698a86df5f18d0bc345580142e.png";